import PropTypes from 'prop-types';
import React from 'react';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import { Route, Switch } from 'react-router-dom';
import MyUtil from '../../functions/MyUtil';
import '../css/Warehouse.css';
import FormBooking from './FormBooking';
import ListBooking from './ListBooking';

const Booking = (props) => {
  const {
    match,
    match: { url },
  } = props;
  return (
    <div>
      <Switch>
        {MyUtil.hasPermission(url, 'view') && (
          <Route
            exact
            path={`${url}`}
            component={() => <ListBooking match_parent={match} />}
          />
        )}
        {MyUtil.hasPermission(url, 'add') && (
          <Route path={`${url}/add-booking`}>
            <FormBooking />
          </Route>
        )}
        {MyUtil.hasPermission(url, 'update') && (
          <Route path={`${url}/edit-booking/:bookingCode`}>
            <FormBooking />
          </Route>
        )}
      </Switch>
    </div>
  );
};

Booking.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default Booking;
